<template>
  <div class="container" style="height:100%;">
      <frontHeadNavigation></frontHeadNavigation>
        <div class="editorArea">
          <div class="editorHead">
        <el-row>
          <el-col :span="8"><el-input v-model="textTitle" placeholder="标题" style="border-bottom:solid 1px black;"></el-input></el-col>
          <el-col :span="4" style="margin-left:20px;"><el-input v-model="textAuthor" placeholder="作者" style="border-bottom:solid 1px black;"></el-input></el-col>
        </el-row>
          <div id="editorHead" class=""></div>
          </div>
          <div id="editorBody" class="editorBody"></div>
        </div>
        <el-button @click="updataResource" class="saveButton">保存</el-button>

  </div>
</template>


<script>
import frontHeadNavigation from '../navigation/frontHeaderNavigation.vue'
import $ from 'jquery'
export default {
  components: {
    frontHeadNavigation
  },
  data () {
    return {
      editor: undefined,
      id: 0, // 文本美钥码ID
      textTitle: '',
      textAuthor: ''
    }
  },
  mounted () {
    const vm = this
    vm.id = this.$route.query.id
    vm.edit = this.$route.query.edit
    // 然后去请求文本信息
    $.ajax({
      type: 'GET',
      url: '/v1/text',
      data: {id: vm.id},
      dataType: 'json',
      success: function (response) {
        // 然后创建编辑框
        let E = window.wangEditor
        vm.editor = new E('#editorHead', '#editorBody')
        vm.editor.customConfig.uploadImgShowBase64 = true
        vm.editor.customConfig.menus = [
          'head',  // 标题
          'bold',  // 粗体
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
          'quote',  // 引用
          'image',  // 插入图片
          'table',  // 表格
          'video',  // 插入视频
          'code',  // 插入代码
          'undo',  // 撤销
          'redo'  // 重复
        ]
        vm.editor.create()
        vm.editor.txt.html(response.data.resource)
        vm.textTitle = response.data.title
        vm.textAuthor = response.data.author
      }
    })
  },
  methods: {
    updataResource () {
      const vm = this
      if (vm.textTitle === '') {
        vm.$message.warning('标题不能为空！')
      } else {
        $.ajax({
          type: 'POST',
          url: '/v1/text/check',
          data: {resource: vm.editor.txt.html()},
          dataType: 'json',
          success: function (response) {
            if (response.data === 'ok') {
              let temp = {text: vm.editor.txt.html(), title: vm.textTitle, author: vm.textAuthor}
              $.ajax({
                type: 'POST',
                url: '/v1/text',
                data: {id: vm.id, resource: JSON.stringify(temp)},
                dataType: 'json',
                success: function (rp) {
                  if (rp.code === 200) {
                    vm.$message.info('保存成功！')
                    vm.$router.push('/labelManage/labelid/all/n/10/p/1')
                  } else if (rp.code === 300007) {
                    vm.$message.warning('存储空间已满，请删除二维码或升级套餐！')
                  } else {
                    vm.$message.warning('更新失败，请稍后重试')
                  }
                }
              })
            } else {
              vm.$message.warning('编辑内容超过单个文本美钥码容量上限，请减小编辑内容的大小！')
            }
          }
        })
      }
    }
  }
}
</script>

<style >
</style>
